import React from "react";

import DividerImage from "../../../../assets/River_Inn_foot.png";

import Classes from "./Index.module.css";

const Index = () => {
  return (
    <>
      <img className={Classes.section_start} src={DividerImage} alt="Divider" />
      <div className={Classes.section_1}>
        <div className={Classes.section_1_content}>
          <p className={Classes.headline}>Explore Places</p>
          <h2>Beaches & Attractions</h2>
          <p>
            Southern Maine is famous for its world class beaches! There are
            three access points to the broad ribbon of beach that stretches
            between Wells and Ogunquit; Moody Beach, Footbridge & Ogunquit
            Beach.
          </p>
          <div className={Classes.buttons}>
            <button className="btn_primary alter">CALL NOW</button>
            <button className="btn_primary">BOOK NOW</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
